Namespace 'Monitoring.Reports.Campaign'

class Monitoring.Reports.Campaign.HeaderView extends Backbone.View
  className: 'header'
  template: JST['backbone/templates/monitoring/reports/campaign/header']

  initialize: (@options = {}) ->
    # just set @options

  render: ->
    @$el.html @template _.extend @options,
      egmnt_evolution: @containsFacebookPost()
    @_renderDatePicker()
    this

  containsFacebookPost: =>
    for post in @options.posts
      return true if post.type is 'facebook'
    false

  _renderDatePicker: ->
    threeYearsAgo = new Date()
    threeYearsAgo.setFullYear(threeYearsAgo.getFullYear() - 3)
    @$('.date').datepicker(
      autoclose: true
      startDate: threeYearsAgo
      endDate: new Date()
      format: 'dd/mm/yyyy'
      todayBtn: 'linked'
      todayHighlight: true
    )
    @timeZoneSelectorView = new Monitoring.Views.TimeZoneSelectorView()
    @$el.find('#time_zone_selector').html(@timeZoneSelectorView.render().el)

    return this

  containsFacebookPost: =>
    for post in @options.posts
      if post.type == "facebook"
        return true
    return false

  getFromDate: =>
    @_getDateFromString(@$el.find('#from').val(), '00:00:00').toISOString()

  getToDate: =>
    @_getDateFromString(@$el.find('#to').val(), '23:59:59').toISOString()

  _getDateFromString: (dateStr, time) =>
    dateStr = "#{dateStr} #{time} #{@_selectedTimeZone()}"
    Date.create dateStr, 'DD/MM/YYYY HH:mm:ss ZZ'

  _selectedTimeZone: =>
    @timeZoneSelectorView.getSelectedTimeZone()
